import React, { useState } from 'react';
import { MapPin, CreditCard, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Company Info */}
          <div>
            <h3 className="text-base font-semibold text-white mb-2">Halsystem</h3>
            <p className="text-xs mb-1">
              オークション出品を効率化するAIツール。<br />
            商品タイトル生成、一括画像処理、テンプレート管理など、<br />
          出品作業を大幅に効率化します。
            </p>
          </div>

          {/* Legal Information */}

        </div>
        
        <div className="border-t border-gray-800 mt-3 pt-3 text-xs text-center">
          <p>© {new Date().getFullYear()} 株式会社クローバー All rights reserved.</p>
          <div className="mt-2 flex justify-center gap-4">
            <Link to="/privacy" className="hover:text-blue-400 transition-colors">
              プライバシーポリシー
            </Link>
            <Link to="/terms" className="hover:text-blue-400 transition-colors" aria-current="page">
              利用規約
            </Link>
            <Link to="/legal" className="hover:text-blue-400 transition-colors">
              特定商取引法に基づく表記
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* Original expanded footer with toggle
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Halsystem</h3>
            <p className="text-sm mb-4">
              オークション出品を効率化するAIツール。商品タイトル生成、一括画像処理、テンプレート管理など、出品作業を大幅に効率化します。
            </p>
            <div className="flex items-center gap-2 mb-2">
              <Mail className="w-4 h-4" />
              <a href="mailto:hal.masaharu@gmail.com" className="text-sm hover:text-blue-400 transition-colors">
                hal.masaharu@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <span className="text-sm">080-5403-1349</span>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">クイックリンク</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-blue-400 transition-colors">
                  ホーム
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm hover:text-blue-400 transition-colors">
                  料金プラン
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-sm hover:text-blue-400 transition-colors">
                  ヘルプセンター
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-sm hover:text-blue-400 transition-colors">
                  マイアカウント
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <button
              onClick={toggleLegalInfo}
              className="flex items-center justify-between w-full text-lg font-semibold text-white mb-4"
            >
              <span>特定商取引法に基づく表記</span>
              {isLegalInfoOpen ? (
                <ChevronUp className="w-5 h-5" />
              ) : (
                <ChevronDown className="w-5 h-5" />
              )}
            </button>
            
            {isLegalInfoOpen && (
              <div className="text-sm space-y-4 bg-gray-800 p-4 rounded-lg">
                <div>
                  <h4 className="font-medium text-white mb-1">事業者</h4>
                  <p>株式会社クローバー</p>
                </div>
                
                <div>
                  <h4 className="font-medium text-white mb-1">代表者</h4>
                  <p>木村 まさはる</p>
                </div>
                
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-medium text-white mb-1">所在地</h4>
                    <p>〒277-0863 千葉県柏市豊四季１６７−４１</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <Phone className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-medium text-white mb-1">電話番号</h4>
                    <p>080-5403-1349</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-medium text-white mb-1">メールアドレス</h4>
                    <p>hal.masaharu@gmail.com</p>
                  </div>
                </div>
                
                <div>
                  <h4 className="font-medium text-white mb-1">販売価格</h4>
                  <ul className="list-disc list-inside pl-2">
                    <li>ベーシックプラン: 2,980円/月（税込）</li>
                    <li>スタンダードプラン: 4,980円/月（税込）</li>
                    <li>プロフェッショナルプラン: 9,800円/月（税込）</li>
                    <li>エンタープライズプラン: 14,800円/月（税込）</li>
                    <li>追加AIクレジット: 3,000円/1,000回（税込）</li>
                  </ul>
                </div>
                
                <div className="flex items-start gap-2">
                  <CreditCard className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-medium text-white mb-1">支払方法</h4>
                    <p>クレジットカード決済のみ（Visa, Mastercard, American Express, JCB）</p>
                  </div>
                </div>
                
                <div>
                  <h4 className="font-medium text-white mb-1">商品の引渡時期</h4>
                  <p>お申し込み完了後、即時にサービスをご利用いただけます。</p>
                </div>
                
                <div className="flex items-start gap-2">
                  <ShieldCheck className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-medium text-white mb-1">返品・キャンセルについて</h4>
                    <p>
                      デジタルコンテンツの性質上、お申し込み後のキャンセル・返金はお受けしておりません。
                      ただし、サービス提供に重大な不具合があった場合は、個別にご対応いたします。
                      サブスクリプションは、いつでも解約可能です。解約後は次回の請求日以降、サービスのご利用ができなくなります。
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
*/